/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type {
  RescheduleScheduledAIWebCallPayload,
  RescheduleScheduledAIWebCallResponse,
  ScheduleScheduledAIWebCallPayload,
  ScheduleScheduledAIWebCallResponse,
  ScheduledAIWebCallByCallIdResponse,
  ScheduledAIWebCallDetailsResponse,
  ScheduledAIWebCallStartResponse,
  ScheduledAIWebCallTimelineResponse,
  ScheduledAiWebCallsGetScheduledAiWebCallParams,
  ScheduledAiWebCallsGetScheduledAiWebCallTimelineParams,
  WebCallLinkResponse,
} from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getScheduledAiWebCalls = () => {
  /**
 * Schedule a **scheduled AI web call** (candidate picks a time to take the AI interview).

Backwards-compatible alias: `/interviews/schedule`.
 * @summary Schedule Scheduled Ai Web Call
 */
  const scheduledAiWebCallsScheduleScheduledAiWebCall = (
    scheduleScheduledAIWebCallPayload: ScheduleScheduledAIWebCallPayload,
    options?: SecondParameter<
      typeof axiosInstance<ScheduleScheduledAIWebCallResponse>
    >
  ) => {
    return axiosInstance<ScheduleScheduledAIWebCallResponse>(
      {
        url: `/scheduled_ai_web_calls/schedule`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: scheduleScheduledAIWebCallPayload,
      },
      options
    );
  };
  /**
   * Reschedule an existing scheduled AI web call. Backwards alias: `/interviews/reschedule`.
   * @summary Reschedule Scheduled Ai Web Call
   */
  const scheduledAiWebCallsRescheduleScheduledAiWebCall = (
    rescheduleScheduledAIWebCallPayload: RescheduleScheduledAIWebCallPayload,
    options?: SecondParameter<
      typeof axiosInstance<RescheduleScheduledAIWebCallResponse>
    >
  ) => {
    return axiosInstance<RescheduleScheduledAIWebCallResponse>(
      {
        url: `/scheduled_ai_web_calls/reschedule`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: rescheduleScheduledAIWebCallPayload,
      },
      options
    );
  };
  /**
   * Get scheduled AI web call details by ID. Backwards alias: `/interviews/{interview_id}`.
   * @summary Get Scheduled Ai Web Call
   */
  const scheduledAiWebCallsGetScheduledAiWebCall = (
    scheduledAiWebCallId: string | null,
    params?: ScheduledAiWebCallsGetScheduledAiWebCallParams,
    options?: SecondParameter<
      typeof axiosInstance<ScheduledAIWebCallDetailsResponse>
    >
  ) => {
    return axiosInstance<ScheduledAIWebCallDetailsResponse>(
      {
        url: `/scheduled_ai_web_calls/${scheduledAiWebCallId}`,
        method: 'GET',
        params,
      },
      options
    );
  };
  /**
   * Get timeline events for a scheduled AI web call. Backwards alias: `/interviews/{interview_id}/timeline`.
   * @summary Get Scheduled Ai Web Call Timeline
   */
  const scheduledAiWebCallsGetScheduledAiWebCallTimeline = (
    scheduledAiWebCallId: string | null,
    params?: ScheduledAiWebCallsGetScheduledAiWebCallTimelineParams,
    options?: SecondParameter<
      typeof axiosInstance<ScheduledAIWebCallTimelineResponse>
    >
  ) => {
    return axiosInstance<ScheduledAIWebCallTimelineResponse>(
      {
        url: `/scheduled_ai_web_calls/${scheduledAiWebCallId}/timeline`,
        method: 'GET',
        params,
      },
      options
    );
  };
  /**
   * Lookup scheduled AI web call ID by call_id. Backwards alias: `/call/{call_id}/interview`.
   * @summary Get Scheduled Ai Web Call By Call Id
   */
  const scheduledAiWebCallsGetScheduledAiWebCallByCallId = (
    callId: string,
    options?: SecondParameter<
      typeof axiosInstance<ScheduledAIWebCallByCallIdResponse>
    >
  ) => {
    return axiosInstance<ScheduledAIWebCallByCallIdResponse>(
      { url: `/call/${callId}/scheduled_ai_web_call`, method: 'GET' },
      options
    );
  };
  /**
 * Track when a candidate actually starts their scheduled AI web call.

The web call page reports every start, so a call that was never scheduled answers 200 with
``tracked`` False.
 * @summary Track Scheduled Ai Web Call Start
 */
  const scheduledAiWebCallsTrackScheduledAiWebCallStart = (
    callId: string,
    options?: SecondParameter<
      typeof axiosInstance<ScheduledAIWebCallStartResponse>
    >
  ) => {
    return axiosInstance<ScheduledAIWebCallStartResponse>(
      { url: `/scheduled_ai_web_calls/start/${callId}`, method: 'POST' },
      options
    );
  };
  /**
 * Get the candidate's web call link for a call (used by scheduling flows).

The link URL is the candidate's interview credential, so this requires a recruiter session
with VIEW on the call's job. Candidate sessions cannot retrieve invitation credentials.
Calls in other orgs and jobs the caller cannot view
both answer 404, like unknown ids.
 * @summary Get Web Call Link By Call Id
 */
  const scheduledAiWebCallsGetWebCallLinkByCallId = (
    callId: string,
    options?: SecondParameter<typeof axiosInstance<WebCallLinkResponse>>
  ) => {
    return axiosInstance<WebCallLinkResponse>(
      { url: `/scheduled_ai_web_calls/web_call_link/${callId}`, method: 'GET' },
      options
    );
  };
  return {
    scheduledAiWebCallsScheduleScheduledAiWebCall,
    scheduledAiWebCallsRescheduleScheduledAiWebCall,
    scheduledAiWebCallsGetScheduledAiWebCall,
    scheduledAiWebCallsGetScheduledAiWebCallTimeline,
    scheduledAiWebCallsGetScheduledAiWebCallByCallId,
    scheduledAiWebCallsTrackScheduledAiWebCallStart,
    scheduledAiWebCallsGetWebCallLinkByCallId,
  };
};
export type ScheduledAiWebCallsScheduleScheduledAiWebCallResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getScheduledAiWebCalls
      >['scheduledAiWebCallsScheduleScheduledAiWebCall']
    >
  >
>;
export type ScheduledAiWebCallsRescheduleScheduledAiWebCallResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getScheduledAiWebCalls
      >['scheduledAiWebCallsRescheduleScheduledAiWebCall']
    >
  >
>;
export type ScheduledAiWebCallsGetScheduledAiWebCallResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getScheduledAiWebCalls
      >['scheduledAiWebCallsGetScheduledAiWebCall']
    >
  >
>;
export type ScheduledAiWebCallsGetScheduledAiWebCallTimelineResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getScheduledAiWebCalls
        >['scheduledAiWebCallsGetScheduledAiWebCallTimeline']
      >
    >
  >;
export type ScheduledAiWebCallsGetScheduledAiWebCallByCallIdResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof getScheduledAiWebCalls
        >['scheduledAiWebCallsGetScheduledAiWebCallByCallId']
      >
    >
  >;
export type ScheduledAiWebCallsTrackScheduledAiWebCallStartResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getScheduledAiWebCalls
      >['scheduledAiWebCallsTrackScheduledAiWebCallStart']
    >
  >
>;
export type ScheduledAiWebCallsGetWebCallLinkByCallIdResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<
        typeof getScheduledAiWebCalls
      >['scheduledAiWebCallsGetWebCallLinkByCallId']
    >
  >
>;
